module.exports = __webpack_public_path__ + "img/2.98c03bc1.jpg";